"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAverageAge = void 0;
function calculateAverageAge(ageValues) {
    let sum = 0;
    Object.keys(ageValues).forEach(range => {
        const ages = range.match(/\d+/g);
        if (!ages)
            return;
        const age = ages.length > 1 ? (parseInt(ages[0]) + parseInt(ages[1])) / 2 : parseInt(ages[0]);
        sum += ageValues[range] * age;
    });
    return sum / 100; //Assume sum of values is 100%
}
exports.calculateAverageAge = calculateAverageAge;
//# sourceMappingURL=calculateAverageAge.js.map